module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "tag rounded",
    class: {
      'w-100': !_vm.short, 'mr-2': _vm.short, 'mb-2': _vm.optionsCount > 1
    }
  }, [_c('tr', [(_vm.image !== null) ? _c('td', {
    staticClass: "image align-top p-0"
  }, [_c('img', {
    attrs: {
      "src": _vm.image,
      "alt": _vm.option[_vm.titleName]
    }
  })]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-left align-middle p-2",
    class: {
      'w-100': !_vm.short
    }
  }, [_vm._v(_vm._s(_vm.option[_vm.titleName]))]), _vm._v(" "), _c('td', {
    staticClass: "action p-2",
    on: {
      "click": function($event) {
        _vm.onDrop(_vm.option, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33d5b3fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tags/Tag.vue
// module id = 100
// module chunks = 0